module.exports = __webpack_public_path__ + "static/media/akhandeshwar-temple.9106e58e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/akhandeshwar-temple.jpeg
// module id = 533
// module chunks = 0